<template>
  <router-view
    v-if="game"
    :game="game"
    :player-id="currentPlayerId"
  />
</template>

<script>
import _throttle from 'lodash/throttle'
import Repositories from 'src/repositories'
import { mapActions, mapGetters } from 'vuex'

import AVAILABLE_STATUS from '../availableStatus'

export default {
  name: 'NetworkDiagramContainer',
  props: {
    gameId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    game: null,
  }),
  computed: {
    ...mapGetters('me', {
      trainingSessionPlayerId: 'trainingSessionPlayerId',
    }),
    ...mapGetters('session', {
      gameStatusListByResourceId: 'gameStatusListByResourceId',
      gameNameListByResourceId: 'gameNameListByResourceId',
    }),
    gameStatus () {
      return this.gameStatusListByResourceId[this.gameId]
    },
    gameName () {
      return this.gameNameListByResourceId[this.gameId]
    },
    currentPlayer () {
      return this.game?.playerList
        ?.find(player => player.trainingSessionPlayerId === this.trainingSessionPlayerId)
    },
    currentPlayerId () {
      return this.currentPlayer?.id
    },
    currentPlayerStatus () {
      return this.currentPlayer?.status
    },
    expectedRouteName () {
      return this.$options.expectedRoutesForStatus[this.currentPlayerStatus]
    },
    isExpectedRouteName () {
      return this.$route.name === this.expectedRouteName
    },
  },
  watch: {
    expectedRouteName () {
      this.ensureRouteIsValid()
    },
    gameStatus () {
      if (this.gameStatus !== 'opened') {
        this.$router.go(-1)
      }
    },
    gameName: {
      immediate: true,
      handler () {
        this.setTitle(this.$t(`home.game.title.${this.gameName}`))
      },
    },
  },
  created () {
    this.fetchData()
  },
  methods: {
    ...mapActions('ui', {
      setTitle: 'setTitle',
      showSuccessNotification: 'showSuccessNotification',
      showErrorNotification: 'showErrorNotification',
    }),
    fetchData: _throttle(async function fetchData () {
      this.game = {
        ...await Repositories.networkdiagram.get(this.gameId),
        hasInstructions: this.gameName === 'networkDiagramWithInstructions',
      }
    }, 200, { leading: true, trailing: true }),
    ensureRouteIsValid () {
      if (this.expectedRouteName && !this.isExpectedRouteName) {
        this.$router.replace({ name: this.expectedRouteName })
      }
    },
    async sendPlayerAction (actionName, actionData, { avoidFetchData } = {}) {
      try {
        await Repositories.networkdiagramPlayer.sendAction({
          gameId: this.game.id,
          playerId: this.currentPlayerId,
          actionName,
          actionData,
        })
        if (!avoidFetchData) {
          await this.fetchData()
        }
      }
      catch (error) {
        this.showErrorNotification(Repositories.parseErrorMessage(error))
        console.error(error)
      }
    },
  },
  provide () {
    return {
      sendPlayerAction: this.sendPlayerAction,
    }
  },
  expectedRoutesForStatus: {
    [AVAILABLE_STATUS.ready]: 'NetworkDiagramWelcome',
    [AVAILABLE_STATUS.playing]: 'NetworkDiagramPlaying',
    [AVAILABLE_STATUS.finished]: 'NetworkDiagramFinished',
  },
}
</script>
